import { useCallback, useEffect, useState } from 'react';

import type { Player } from '@schibsted-svp/web-player';

import { getPlayer } from '../playerService';

export const usePlayer = () => {
  const [player, setPlayer] = useState<Player>();

  const onPlayerReady = useCallback(
    () =>
      getPlayer()
        .then((playerInstance) => {
          if (playerInstance !== player) {
            setPlayer(playerInstance);
          }
        })
        .catch((e) => console.error(e)),
    [player]
  );

  useEffect(() => {
    document.addEventListener('playerReady', onPlayerReady);

    return () => {
      document.removeEventListener('playerReady', onPlayerReady);
    };
  }, []);

  useEffect(() => {
    onPlayerReady();
  }, []);

  return player;
};
